import React from 'react'
import { inject, observer } from 'mobx-react'
import { Button, Checkbox, Modal, Select, Spin, Tooltip } from 'antd'
import commissions from '@services/commissions'
import { alertPopup } from '@utils/popup'
import MathExpr, { op } from '../MathExpr'
import SubscriptionOptionLabel from '../SubscriptionOptionLabel'
import { historySubs } from '../historySubs'
import { COMMISSION_SELECT_STYLES } from '../commissionSelectStyles'

@inject(({ popupStore, mentorCommissionStore }) => ({ popupStore, mentorCommissionStore }))
@observer
export default class MentorDebtCommission extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loadingSubmit: false,
            loadingData: false,
            noEligibleSub: false,
            subscriptionsToDisplay: [],
            selectedSubscription: {},
            months_to_charge: 0,
            comment: ''
        }
    }

    componentDidMount() {
        this.getMentorCommissions()
    }

    componentDidUpdate(prevProps, prevState) {
        if (!prevState.mentorCommissions && this.state.mentorCommissions) {
            this.setSubscriptionList()
        }

        if (prevState.selectedSubscription.id != this.state.selectedSubscription.id) {
            this.setSomeData()
        }
    }

    getMentorCommissions = () => {
        this.setState({ loadingData: true }, () => {
            const {
                popupStore: {
                    info: {
                        clientAgentInfo: {
                            selectedClient: { client_id }
                        },
                        agentInfo: { id: agent_id, mentor_id }
                    }
                }
            } = this.props

            commissions
                .getMentorCommissionsByAgentClient({ mentor_id, agent_id, client_id })
                .then(res => {
                    if (res.data.length) this.setState({ mentorCommissions: res.data })
                })
                .catch(() => {})
                .finally(() => this.setState({ loadingData: false }))
        })
    }

    setSubscriptionList = () => {
        const {
            clientAgentInfo: { recentClientSubscriptions, selectedClient }
        } = this.props.popupStore.info
        let subscriptionsToDisplay = historySubs(selectedClient, recentClientSubscriptions)

        if (subscriptionsToDisplay.length === 0) {
            this.setState({ noEligibleSub: true })
        }

        const noAgentDebtcommission = !this.hasAgentDebtCommission()

        if (subscriptionsToDisplay.length) {
            this.setState({
                subscriptionsToDisplay,
                selectedSubscription: subscriptionsToDisplay[0],
                noAgentDebtcommission
            })
        }
    }

    subscriptionHasCommission = userSubId => {
        const { mentorCommissions } = this.state
        let found = false
        mentorCommissions.forEach(({ user_subscription_id, user_special_subscription_id, status, balance }) => {
            if (balance == 'DEBT' && status == 'ACTIVE') {
                if ([user_special_subscription_id + '', user_subscription_id + ''].includes(userSubId + '')) {
                    found = true
                }
            }
        })
        return found
    }

    hasAgentDebtCommission = () => {
        const {
            info: {
                clientAgentInfo: { recentClientSubscriptions, clientCommissions }
                // agentInfo: { mentor_id, mentor_percent, monthly_commission, advanced_commission }
            }
        } = this.props.popupStore

        if (clientCommissions && clientCommissions.commissions) {
            let found = false
            recentClientSubscriptions.forEach(sub => {
                clientCommissions.commissions.forEach(({ balance, status, user_subscription_id }) => {
                    if (balance === 'DEBT' && status === 'ACTIVE' && user_subscription_id == sub.user_subscription_id) {
                        found = true
                    }
                })
            })

            return found
        }
    }

    selectSubscription = id => {
        const { subscriptionsToDisplay } = this.state
        let selectedSubscription = subscriptionsToDisplay.find(({ select_id }) => select_id == id)

        this.setState({ selectedSubscription })
    }

    setSomeData = () => {
        const { selectedSubscription, mentorCommissions } = this.state
        const {
            info: {
                clientAgentInfo,
                agentInfo: { advanced_commission }
            }
        } = this.props.popupStore

        let agentClientCommissions
        let agentCommission
        if (clientAgentInfo.clientCommissions && clientAgentInfo.clientCommissions.commissions) {
            agentClientCommissions = clientAgentInfo.clientCommissions.commissions
            agentCommission = agentClientCommissions.find(
                ({ user_subscription_id, balance }) =>
                    balance === 'DEBT' && user_subscription_id == selectedSubscription.user_subscription_id
            )
        }

        let creditMentorCommission = mentorCommissions.find(
            ({ balance, user_subscription_id, user_special_subscription_id }) =>
                balance == 'CREDIT' &&
                [user_subscription_id + '', user_special_subscription_id + ''].includes(
                    selectedSubscription.user_subscription_id + ''
                )
        )
        let months_to_charge
        if (agentCommission && agentCommission.months_to_charge) {
            months_to_charge = 12 - (advanced_commission - agentCommission.months_to_charge)
        } else if (creditMentorCommission) {
            let creditDate = new Date()
            creditDate.setFullYear(
                creditMentorCommission.year ? creditMentorCommission.year + 2000 : new Date().getFullYear()
            )
            creditDate.setMonth(creditMentorCommission.month - 1)

            let now = new Date()

            months_to_charge = (now.getFullYear() - creditDate.getFullYear()) * 12
            months_to_charge -= creditDate.getMonth()
            months_to_charge += now.getMonth()
            months_to_charge = months_to_charge >= 0 ? months_to_charge : 0
            months_to_charge = 12 - months_to_charge
        }

        this.setState({ agentCommission, creditMentorCommission, months_to_charge })
    }

    onClose = () => {
        this.props.popupStore.togglePopup(false)
    }

    submit = () => {
        const { selectedSubscription, agentCommission, creditMentorCommission, months_to_charge, comment } = this.state

        const {
            info: {
                clientAgentInfo: {
                    selectedClient: { client_id }
                },
                agentInfo: { id: agent_id, mentor_id, mentor_percent }
            }
        } = this.props.popupStore

        const { mentorCommissionStore } = this.props

        const payload = {
            mentor_id,
            user_subscription_id: selectedSubscription.specialSub ? null : selectedSubscription.user_subscription_id,
            user_special_subscription_id: selectedSubscription.specialSub
                ? selectedSubscription.user_subscription_id
                : null,
            amount: selectedSubscription.price, // * months/months_to_charge ???
            percent: mentor_percent,
            months_to_charge,
            month: new Date().getMonth() + 1,
            year: new Date().getFullYear() - 2000,
            agent_commission_id: agentCommission ? agentCommission.id : null,
            balance: 'DEBT',
            payment_type: 'ONE_TIME',
            status: 'ACTIVE',
            credit_commission_id: creditMentorCommission.id
        }

        this.setState({ loadingSubmit: true }, () => {
            commissions
                .createMentorCommission(payload)
                .then(res => {
                    mentorCommissionStore.getMentorCommissions({ agent_id, mentor_id, client_id })
                    alertPopup({ type: 'success', title: 'עמלת מנטור נוצרה בהצלחה', body: '' })
                })
                .catch(error => {
                    console.log('error. create mentor commission', error)
                    alertPopup({ type: 'error', title: 'אירעה שגיאה', body: '' })
                })
        })
    }

    render() {
        const {
            loadingSubmit,
            noEligibleSub,
            selectedSubscription,
            noAgentDebtcommission,
            months_to_charge,
            comment,
            subscriptionsToDisplay
        } = this.state

        let {
            popupStore: {
                info: { agentInfo, clientAgentInfo }
            }
        } = this.props

        let selectedClient = {}
        let recentClientSubscriptions = []

        if (clientAgentInfo) {
            selectedClient = clientAgentInfo.selectedClient
            recentClientSubscriptions = clientAgentInfo.recentClientSubscriptions
        }

        return (
            <Modal
                onCancel={this.onClose}
                visible={this.props.popupStore.popupType === 'mentorDebtCommission'}
                title={`חיוב למנטור: ${agentInfo.mentor}`}
                footer={null}
                width="720px"
            >
                <style>{COMMISSION_SELECT_STYLES}</style>
                <div style={{ ...style.column, paddingInline: '30px', margin: '0 0 15px 0' }}>
                    <div style={{ ...style.formLine }}>
                        <span>{'שם הסוכן:'}</span>
                        <div style={{ width: '70%', display: 'flex' }}>
                            <span>{`${agentInfo.first_name} ${agentInfo.last_name}`}</span>
                        </div>
                    </div>

                    <div style={{ ...style.formLine }}>
                        <span>{'הלקוח:'}</span>
                        <div style={{ width: '70%', display: 'flex' }}>
                            <span>{`${selectedClient.client_first_name} ${selectedClient.client_last_name}`}</span>
                        </div>
                    </div>

                    {/* {noEligibleSub ?
                        <span>{"לא נמצאו מינויים מבוטלים עבורם אין עמלת חיוב"}</span> : */}
                    <div style={{ ...style.column }}>
                        <div style={{ ...style.formLine }}>
                            <span>{'המינוי:'}</span>
                            <div style={{ width: '70%', display: 'flex' }}>
                                <Select
                                    className="commission-select"
                                    dropdownClassName="commission-dropdown"
                                    value={(selectedSubscription || {}).select_id}
                                    onChange={this.selectSubscription}
                                    style={{ width: '100%' }}
                                    dropdownMatchSelectWidth={false}
                                >
                                    {(subscriptionsToDisplay || []).map((sub, idx) => {
                                        return (
                                            <Select.Option
                                                value={sub.select_id}
                                                style={{ paddingInline: '8px' }}
                                                title={sub.name}
                                                key={idx.toString()}
                                            >
                                                <SubscriptionOptionLabel
                                                    name={sub.name}
                                                    subscription_status={sub.subscription_status}
                                                    paid_at={sub.paid_at}
                                                />
                                            </Select.Option>
                                        )
                                    })}
                                </Select>
                            </div>
                        </div>

                        {noAgentDebtcommission ? (
                            <div style={{ ...style.formLine }}>
                                <span></span>
                                <strong style={{ display: 'inline-block', width: '70%' }}>
                                    {'לא נמצאה עמלת חיוב מתאימה אצל הסוכן'}
                                </strong>
                            </div>
                        ) : (
                            ''
                        )}

                        <div style={{ ...style.formLine }}>
                            <span>{'מחיר:'}</span>
                            <div style={{ width: '70%', display: 'flex' }}>
                                <span>{selectedSubscription.price}</span>
                            </div>
                        </div>

                        <div style={{ ...style.formLine }}>
                            <span>{'חודשים:'}</span>
                            <div style={{ width: '70%', display: 'flex' }}>
                                <Select
                                    className="commission-select"
                                    dropdownClassName="commission-dropdown"
                                    onChange={m => this.setState({ months_to_charge: m })}
                                    value={months_to_charge}
                                    style={{ width: '100%' }}
                                >
                                    {new Array(30).fill(null).map((_, num) => (
                                        <Select.Option value={num + 1} title={''} key={num.toString()}>
                                            {num + 1}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </div>
                        </div>

                        <div style={{ ...style.formLine }}>
                            <span>{'עמלת מנטור:'}</span>
                            <div style={{ width: '70%', display: 'flex' }}>
                                <Tooltip
                                    title={
                                        <MathExpr
                                            tokens={[
                                                { value: selectedSubscription.price },
                                                op('×'),
                                                { value: agentInfo.mentor_percent },
                                                op('×'),
                                                { value: months_to_charge }
                                            ]}
                                        />
                                    }
                                >
                                    <span>
                                        {`${(selectedSubscription.price * agentInfo.mentor_percent * months_to_charge)
                                            .toFixed(2)
                                            .replace(/[^0-9.]*((\d*\.?\d{0,9})).*/g, '$2')}`}
                                    </span>
                                </Tooltip>
                            </div>
                        </div>

                        <Button disabled={loadingSubmit} onClick={this.submit} style={{ alignSelf: 'center' }}>
                            {loadingSubmit ? <Spin /> : 'שמירה'}
                        </Button>
                    </div>
                    {/* } */}
                </div>
            </Modal>
        )
    }
}

const style = {
    column: { display: 'flex', flexDirection: 'column' },
    formLine: { display: 'flex', justifyContent: 'space-between', width: '100%', marginBottom: '15px' },
    box: {
        background: 'white',
        border: 'solid 1px #d1d1d1',
        height: '32px',
        paddingInline: '15px',
        fontSize: '14px',
        display: 'flex',
        alignItems: 'center'
    },
    rightBox: { cursor: 'pointer', borderRadius: '0 4px 4px 0' },
    leftBox: { cursor: 'pointer', borderRadius: '4px 0 0 4px' }
}
